/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  CreateAdminStocktakeResponse,
  GetAdminStocktakeCompletableResponse,
  GetAdminStocktakeReviewParams,
  GetAdminStocktakeReviewResponse,
  UpdateAdminStocktakeRequest,
  UpdateAdminStocktakeResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useGetAdminStocktakeCompletableHook = () => {
        const getAdminStocktakeCompletable = useCustomInstance<GetAdminStocktakeCompletableResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getAdminStocktakeCompletable(
          {url: `/AdminStocktake/GetCompletable`, method: 'GET', signal
    },
          );
        }, [getAdminStocktakeCompletable])
      }
    

export const getGetAdminStocktakeCompletableQueryKey = () => {
    return [`/AdminStocktake/GetCompletable`] as const;
    }

    
export const useGetAdminStocktakeCompletableQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStocktakeCompletableQueryKey();

  const getAdminStocktakeCompletable =  useGetAdminStocktakeCompletableHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>> = ({ signal }) => getAdminStocktakeCompletable(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminStocktakeCompletableQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>>
export type GetAdminStocktakeCompletableQueryError = unknown


export function useGetAdminStocktakeCompletable<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStocktakeCompletable<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStocktakeCompletable<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminStocktakeCompletable<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeCompletableHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAdminStocktakeCompletableQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useUpdateAdminStocktakeHook = () => {
        const updateAdminStocktake = useCustomInstance<UpdateAdminStocktakeResponse>();

        return useCallback((
    updateAdminStocktakeRequest: UpdateAdminStocktakeRequest,
 ) => {
        return updateAdminStocktake(
          {url: `/AdminStocktake/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAdminStocktakeRequest
    },
          );
        }, [updateAdminStocktake])
      }
    


export const useUpdateAdminStocktakeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAdminStocktakeHook>>>, TError,{data: UpdateAdminStocktakeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAdminStocktakeHook>>>, TError,{data: UpdateAdminStocktakeRequest}, TContext> => {

const mutationKey = ['updateAdminStocktake'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateAdminStocktake =  useUpdateAdminStocktakeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateAdminStocktakeHook>>>, {data: UpdateAdminStocktakeRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateAdminStocktake(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminStocktakeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateAdminStocktakeHook>>>>
    export type UpdateAdminStocktakeMutationBody = UpdateAdminStocktakeRequest
    export type UpdateAdminStocktakeMutationError = unknown

    export const useUpdateAdminStocktake = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateAdminStocktakeHook>>>, TError,{data: UpdateAdminStocktakeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateAdminStocktakeHook>>>,
        TError,
        {data: UpdateAdminStocktakeRequest},
        TContext
      > => {

      const mutationOptions = useUpdateAdminStocktakeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useCreateAdminStocktakeHook = () => {
        const createAdminStocktake = useCustomInstance<CreateAdminStocktakeResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return createAdminStocktake(
          {url: `/AdminStocktake/Create`, method: 'POST', signal
    },
          );
        }, [createAdminStocktake])
      }
    


export const useCreateAdminStocktakeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAdminStocktakeHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAdminStocktakeHook>>>, TError,void, TContext> => {

const mutationKey = ['createAdminStocktake'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createAdminStocktake =  useCreateAdminStocktakeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateAdminStocktakeHook>>>, void> = () => {
          

          return  createAdminStocktake()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminStocktakeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateAdminStocktakeHook>>>>
    
    export type CreateAdminStocktakeMutationError = unknown

    export const useCreateAdminStocktake = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAdminStocktakeHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateAdminStocktakeHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = useCreateAdminStocktakeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useGetAdminStocktakeReviewHook = () => {
        const getAdminStocktakeReview = useCustomInstance<GetAdminStocktakeReviewResponse>();

        return useCallback((
    params?: GetAdminStocktakeReviewParams,
 signal?: AbortSignal
) => {
        return getAdminStocktakeReview(
          {url: `/AdminStocktake/GetReview`, method: 'GET',
        params, signal
    },
          );
        }, [getAdminStocktakeReview])
      }
    

export const getGetAdminStocktakeReviewQueryKey = (params?: GetAdminStocktakeReviewParams,) => {
    return [`/AdminStocktake/GetReview`, ...(params ? [params]: [])] as const;
    }

    
export const useGetAdminStocktakeReviewQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError = unknown>(params?: GetAdminStocktakeReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStocktakeReviewQueryKey(params);

  const getAdminStocktakeReview =  useGetAdminStocktakeReviewHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>> = ({ signal }) => getAdminStocktakeReview(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminStocktakeReviewQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>>
export type GetAdminStocktakeReviewQueryError = unknown


export function useGetAdminStocktakeReview<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError = unknown>(
 params: undefined |  GetAdminStocktakeReviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStocktakeReview<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError = unknown>(
 params?: GetAdminStocktakeReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStocktakeReview<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError = unknown>(
 params?: GetAdminStocktakeReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminStocktakeReview<TData = Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError = unknown>(
 params?: GetAdminStocktakeReviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAdminStocktakeReviewHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAdminStocktakeReviewQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



